import { safeFormatMessage } from '@10xlabs/utils'
import { ReactElement } from 'react'
import { useIntl } from 'react-intl'
import { ThemeProvider } from 'styled-components'

import { Container, IChipContainerTheme } from 'components/Chip'
import { vehicleStatusMessages } from 'features/Vehicles/components/Status/messages'
import { GTVehicleStatus } from 'gql/types.generated'

const getTheme = (status: GTVehicleStatus): IChipContainerTheme => {
  switch (status) {
    case GTVehicleStatus.Active:
      return { backgroundColor: '#00C875', color: '#fff' }
    case GTVehicleStatus.Inactive:
      return { backgroundColor: '#B0B0B0', color: '#fff' }
    case GTVehicleStatus.OutOfService:
      return { backgroundColor: '#FFA800', color: '#fff' }
    default: {
      return { backgroundColor: '#fff', color: '#000' }
    }
  }
}

interface IVehicleStatusProps {
  status: GTVehicleStatus
}

export const VehicleStatus = ({ status }: IVehicleStatusProps): ReactElement => {
  const intl = useIntl()

  return (
    <ThemeProvider theme={getTheme(status)}>
      <Container>{safeFormatMessage({ intl, messages: vehicleStatusMessages, key: status })}</Container>
    </ThemeProvider>
  )
}
